import React from "react";
import "./Dates.css";

const DateTomorrow = () => {
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  return (
    <div className="dateToday">
      <span className="date">{tomorrow.toDateString()}</span>
    </div>
  );
};

export default DateTomorrow;
